"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastEpisodeRefProperty = exports.podcastEpisodeRefPropertyDefinition = void 0;
exports.podcastEpisodeRefPropertyDefinition = {
    view: {
        label: 'Podcast episodes',
        readonly: true,
        hint: 'Read-only. Please navigate to the content you\'d want to remove or add in order to make changes.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['podcast-episode'],
        },
    ],
    type: 'child-ref',
    multiple: true,
    name: 'podcast-episode-ref',
};
const isPodcastEpisodeRefProperty = (prop) => {
    return prop.name === exports.podcastEpisodeRefPropertyDefinition.name;
};
exports.isPodcastEpisodeRefProperty = isPodcastEpisodeRefProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9kY2FzdC1lcGlzb2RlLXJlZi5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BvZGNhc3QtZXBpc29kZS1yZWYucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxtQ0FBbUMsR0FBRztJQUNqRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsa0JBQWtCO1FBQ3pCLFFBQVEsRUFBRSxJQUFJO1FBQ2QsSUFBSSxFQUFFLGtHQUFrRztLQUN6RztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLENBQUM7U0FDOUI7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLHFCQUFxQjtDQUNJLENBQUE7QUFJMUIsTUFBTSwyQkFBMkIsR0FBRyxDQUFDLElBQWtCLEVBQXFDLEVBQUU7SUFDbkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDJDQUFtQyxDQUFDLElBQUksQ0FBQTtBQUMvRCxDQUFDLENBQUE7QUFGWSxRQUFBLDJCQUEyQiwrQkFFdkMifQ==